import React, { HTMLProps } from 'react';
import { css } from '@emotion/core';

interface Props extends HTMLProps<HTMLAnchorElement> {
  children: React.ReactNode;
}

/**
 * @deprecated import from design-system
 */
export const NakedA = ({ children, ...rest }: Props) => (
  <a
    css={css`
      color: currentColor;
      text-decoration: none;
    `}
    {...rest}
  >
    {children}
  </a>
);
